import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircle, AlertCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { API_BASE_URL } from "../config";



export const AllegroConnectPage = () => {
  const { search } = useLocation();
  const navigate = useNavigate();
  const { setHasAllegroConnected, authFetch } = useAuth();

  const qp = useMemo(() => new URLSearchParams(search), [search]);
  const status = qp.get("status");
  const message = qp.get("message");

  useEffect(() => {
    if (status === "success") {
      // optimistic UI so user sees success immediately
      setHasAllegroConnected(true);
      localStorage.setItem("hasAllegroConnected", "true");

      // confirm with backend (optional; warms token)
      (async () => {
        try { await authFetch(`${API_BASE_URL}/api/user-status/`); } catch {}
        // show the success state for a moment, then go home
        setTimeout(() => navigate("/", { replace: true }), 1500);
      })();
    }
  }, [status, setHasAllegroConnected, authFetch, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-6">
      <div className="bg-white rounded-xl shadow-lg p-8 text-center max-w-md w-full">
        {status === "success" ? (
          <>
            <CheckCircle className="mx-auto text-green-600" size={56} />
            <h1 className="mt-4 text-2xl font-bold text-green-700">Allegro connected! ✅</h1>
            <p className="mt-2 text-gray-600">You will return to the app shortly...</p>
          </>
        ) : (
          <>
            <AlertCircle className="mx-auto text-red-600" size={56} />
            <h1 className="mt-4 text-2xl font-bold text-red-700">Connection error</h1>
            <p className="mt-2 text-gray-600">{message || "Please try again."}</p>
            <button
              onClick={() => navigate("/", { replace: true })}
              className="mt-6 btn-primary"
            >
              Return to the app
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default AllegroConnectPage;
